/**
 * CMS (Wordpress) training resource learning types and service names
 * These specific resource training items have additional table of contents and navigatiion
 * that is unique to these products that require additional layout and formatting.
 */
export enum CmsResourceTrainingSlugs {
  GENESYS_CLOUD_ELEARNING = 'genesys-cloud-cx-elearning',
  GENESYS_CLOUD_ELEARNING_SERVICE_NAME = 'rapidresponse',
  GENESYS_DX_ELEARNING = 'genesys-dx-elearning',
  GENESYS_DX_SERVICE_NAME = 'bold360',
}
